import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEye } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { app } from '../firebase';
import { getFirestore, collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function FeedbackComp() {
  const db = getFirestore(app);
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const q = query(
          collection(db, 'Orders'),
          where('status', '==', 'Completed'),
          orderBy('timestamp', 'desc') // latest orders first
        );
        const snapshot = await getDocs(q);
        const fetchedOrders = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setOrders(fetchedOrders);
      } catch (err) {
        console.error('Error fetching orders:', err);
      }
    };
    fetchOrders();
  }, [db]);

  const filteredOrders = orders.filter(
    order =>
      order.clientName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.fromLocation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.toLocation?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="dataComp p-4">
      <div className="dataCompTop d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold">Trip Feedback</h5>
        <div className="searchContainer d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faSearch} className="searchIcon text-muted" />
          <input
            type="text"
            placeholder="Type to search"
            className="form-control"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Driver Feedback</th>
            <th>Client Feedback</th>
            <th>View Order</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map(order => (
            <tr key={order.id}>
              <td>{order.fromLocation || 'N/A'}</td>
              <td>{order.toLocation || 'N/A'}</td>
              <td>{order.feedback || '-'}</td>
              <td>{order.clientFeedback || '-'}</td>
              <td>
                <Button
                  size="sm"
                  variant="info"
                  onClick={() => navigate(`/orders/${order.id}`)}
                >
                  <FontAwesomeIcon icon={faEye} /> View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default FeedbackComp;